import useColor from '@/hooks/domain/useColor';

import type { IconProps } from './types/types';

const PriorityLowIcon = (props: IconProps) => {
  const colors = useColor();
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6999 6.84797C5.88159 6.71734 6.11829 6.71734 6.29998 6.84797L10.0091 9.51464C10.2576 9.69334 10.3248 10.0555 10.1591 10.3236C9.99339 10.5916 9.65756 10.6641 9.40899 10.4854L5.99994 8.03441L2.59089 10.4854C2.34232 10.6641 2.00649 10.5916 1.84078 10.3236C1.67507 10.0555 1.74224 9.69334 1.9908 9.51464L5.6999 6.84797Z"
        fill={colors.ND60}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6999 4.18098C5.88159 4.05035 6.11829 4.05035 6.29998 4.18098L10.0091 6.84765C10.2576 7.02635 10.3248 7.38852 10.1591 7.65658C9.99339 7.92464 9.65756 7.99708 9.40899 7.81837L5.99994 5.36742L2.59089 7.81837C2.34232 7.99708 2.00649 7.92464 1.84078 7.65658C1.67507 7.38852 1.74224 7.02635 1.9908 6.84765L5.6999 4.18098Z"
        fill={colors.ND12}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6999 1.51496C5.88159 1.38434 6.11829 1.38434 6.29998 1.51496L10.0091 4.18163C10.2576 4.36034 10.3248 4.72251 10.1591 4.99057C9.99339 5.25863 9.65756 5.33106 9.40899 5.15235L5.99994 2.7014L2.59089 5.15235C2.34232 5.33106 2.00649 5.25863 1.84078 4.99057C1.67507 4.72251 1.74224 4.36034 1.9908 4.18163L5.6999 1.51496Z"
        fill={colors.ND12}
      />
    </svg>
  );
};

export default PriorityLowIcon;
